import { useContext, useState } from 'react';
import { DialogContext } from '../../context/DialogContext';
import { TestingHqContext } from '../../context/TestingHqContext';
import { upsert_place } from '../../utils/restapi';
import './join.css';
import Zipcode from '../zipcode';

const PlaceJoin = ({ title, placeObj, onClose }) => {
  const { testingHqs } = useContext(TestingHqContext);
  const { openDialog, closeDialog } = useContext(DialogContext);

  const [obj, setObj] = useState(placeObj || {});

  // 우편번호 선택 핸들러 추가
  const handleZipcodeSelected = (selectedData) => {
    console.log('선택된 우편번호 데이터:', selectedData);
    
    // obj 상태 업데이트
    setObj(prevObj => ({
      ...prevObj,
      zipcode: selectedData.zipcode,
      addressMain: selectedData.addressMain,
      addressDetail: selectedData.addressDetail || ''
    }));
    
    // 우편번호 다이얼로그 닫기
    closeDialog();
  };

  // 우편번호 다이얼로그만 닫는 핸들러
  const handleZipcodeClose = () => {
    console.log('우편번호 다이얼로그 닫기');
    closeDialog();
  };

  const clickZipcodeSearch = () => {
    console.log('우편번호 검색 클릭됨');
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '100vw',
        maxHeight: '100vh',
        overflow: 'auto'
      },
    };

    openDialog(
      <Zipcode
        zipcode={obj.zipcode}
        onSelected={handleZipcodeSelected}
        onClose={handleZipcodeClose}
      />, 
      customStyles
    );
  };

  // 장소 정보 업데이트
  const handleSubmit = async () => {
    console.log('handleSubmit called');
    console.log("handleSubmit json:", obj);

    try {
      const response = await upsert_place(obj);
      console.log("updateTestingPlace:", response);
      alert('고사장 정보가 저장되었습니다.');
      
      // 저장 성공 후 PlaceJoin 다이얼로그 닫기
      if (onClose) {
        onClose();
      }
    } catch (error) {
      console.error("Error updating testing place:", error);
      alert('저장 중 오류가 발생했습니다: ' + error.message);
    }
  };

  // PlaceJoin 다이얼로그 닫는 핸들러
  const handlePlaceJoinClose = () => {
    console.log('PlaceJoin 다이얼로그 닫기');
    if (onClose) {
      onClose();
    }
  };

  return (
    <div id="place_join">
      <div className="head">
        <h1>{title || '고사장 정보'}</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>본부코드</label>
            <span>
              <select name="gcode" value={obj.gcode || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, gcode: e.target.value }))}>
                <option value="">▒ 선택 ▒</option>
                {testingHqs.map((hq, index) => (
                  <option key={index} value={hq.code}>
                    [{hq.code}] {hq.name}
                  </option>
                ))}
              </select>
            </span>
          </li>
          <li>
            <label>고사장코드</label>
            <span>
              <input type="text" value={obj.code || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, code: e.target.value }))} />
            </span>
          </li>
          <li>
            <label>고사장명칭</label>
            <span>
              <input type="text" value={obj.name || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, name: e.target.value }))} />
            </span>
          </li>
          <li>
            <label>주소</label>
            <span>
              <input 
                type="text" 
                value={obj.zipcode || ''} 
                onChange={(e) => setObj(prevObj => ({ ...prevObj, zipcode: e.target.value }))} 
                className="zipcode"
                placeholder="우편번호"
              />
              <button onClick={clickZipcodeSearch} className='btnZipcode'>검색</button>
              <input 
                type="text" 
                value={obj.addressMain || ''} 
                onChange={(e) => setObj(prevObj => ({ ...prevObj, addressMain: e.target.value }))} 
                className="addressMain"
                placeholder="도로명주소"
              />
              <input 
                type="text" 
                value={obj.addressDetail || ''} 
                onChange={(e) => setObj(prevObj => ({ ...prevObj, addressDetail: e.target.value }))} 
                className="addressDetail"
                placeholder="상세주소"
              />
            </span>
          </li>
          <li>
            <label>전화번호</label>
            <span><input type="text" value={obj.phone || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, phone: e.target.value }))} /></span>
          </li>
          <li>
            <label>휴대전화</label>
            <span><input type="text" value={obj.handphone || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, handphone: e.target.value }))} /></span>
          </li>
          <li>
            <label>이메일</label>
            <span><input type="text" value={obj.email || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, email: e.target.value }))} /></span>
          </li>
          <li>
            <label>팩스번호</label>
            <span><input type="text" value={obj.fax || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, fax: e.target.value }))} /></span>
          </li>
          <li>
            <label>홈페이지</label>
            <span><input type="text" value={obj.homepage || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, homepage: e.target.value }))} /></span>
          </li>
          <li>
            <label>장소소개</label>
            <span>
              <textarea value={obj.comment || ''} onChange={(e) => setObj(prevObj => ({ ...prevObj, comment: e.target.value }))} />
            </span>
          </li>
          <li>
            <label>사용여부</label>
            <span>
              <input type="radio" name="isUse" value="1" checked={obj.isUse === 1} onChange={() => setObj(prevObj => ({ ...prevObj, isUse: 1 }))} id='isUse1' /> <label htmlFor='isUse1'>사용</label>
              <input type="radio" name="isUse" value="0" checked={obj.isUse === 0} onChange={() => setObj(prevObj => ({ ...prevObj, isUse: 0 }))} id='isUse0' /> <label htmlFor='isUse0'>사용안함</label>
            </span>
          </li>
        </ul>
      </div>
      <div className="foot">
        <button onClick={handleSubmit}>저장</button>
        <button onClick={handlePlaceJoinClose}>닫기</button>
      </div>
    </div>
  );
};

export default PlaceJoin;